import {
  ArrowRight,
  PackageSearch,
  ShieldCheck,
  ShoppingBag,
} from 'lucide-react';

import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <main>
      <section className="hero">
        <div className="page hero-grid">
          <div>
            <span className="eyebrow">
              Marketplace khusus komunitas kampus
            </span>

            <h1>
              Temukan kebutuhan kuliah dengan mudah di{' '}
              <em>UniLoot</em>
            </h1>

            <p>
              Jelajahi 50 produk awal mulai dari buku,
              elektronik, furnitur, pakaian, sepatu, hingga
              perlengkapan kos. Setiap produk dilengkapi gambar
              yang sesuai.
            </p>

            <div className="hero-actions">
              <Link
                className="btn primary large"
                to="/products"
              >
                Lihat 50 Produk
                <ArrowRight size={19} />
              </Link>

              <Link
                className="btn outline large"
                to="/login"
              >
                Masuk Akun Demo
              </Link>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-icon">
              <ShoppingBag size={110} />
            </div>

            <div className="floating-card one">
              <PackageSearch />

              <b>50 produk</b>

              <span>9 kategori</span>
            </div>

            <div className="floating-card two">
              <ShieldCheck />

              <b>Aman</b>

              <span>JWT login</span>
            </div>
          </div>
        </div>
      </section>

      <section className="page feature-grid">
        <article>
          <PackageSearch />

          <h2>Produk lengkap</h2>

          <p>
            Minimal 50 produk dengan gambar lokal sesuai jenis
            barang.
          </p>
        </article>

        <article>
          <ShoppingBag />

          <h2>Belanja mudah</h2>

          <p>
            Pencarian, filter, detail, keranjang, dan checkout
            terintegrasi.
          </p>
        </article>

        <article>
          <ShieldCheck />

          <h2>Siap pengujian UTS</h2>

          <p>
            Dilengkapi TDD, BDD, UI automation, dan REST API
            automation.
          </p>
        </article>
      </section>
    </main>
  );
}